var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"super-audio-bag"},[_c('svg-icon',{attrs:{"name":"bag"}}),_vm._v("购买配音包 ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }